export const FilterIDs = {
  ContentTypes: 'content-types-filter',
  Publications: 'publications-filter',
  Experiments: 'experiments-filter',
};
